/**
 * The one naming helper `cockpit-data.ts` needs, lifted from Meteoric's
 * `src/lib/naming.ts` verbatim rather than imported.
 *
 * Copying 6 lines is the right call against importing a 200-line module whose
 * other half is Amazon marketplace labelling this surface never asks for. The
 * behaviour is pinned by a test, so a silent drift from the original shows up
 * here rather than as a mislabelled row.
 */
export function safeCode(code: string | null | undefined, opts?: { show?: boolean }): string {
  const trimmed = typeof code === "string" ? code.trim() : "";
  if (!trimmed) return "-";
  return opts?.show ? `Unknown (${trimmed})` : "-";
}

/**
 * Amazon marketplace SHORT CODES, as Machine's `market` field carries them.
 *
 * Lifted with `safeCode` for the same reason: this is the vocabulary Machine's
 * rows are written in, and the alternative is importing Meteoric's whole naming
 * module for two functions. The pass-through for an unrecognised value is
 * load-bearing — `market` also holds prose like "All markets", and mangling
 * that into "ALL MARKETS" would read as a code the reader should recognise.
 */
const MARKETPLACE_CODE_LABELS: Record<string, string> = {
  UK: "Amazon UK",
  US: "Amazon US",
  DE: "Amazon Germany",
  FR: "Amazon France",
  ES: "Amazon Spain",
  IT: "Amazon Italy",
  NL: "Amazon Netherlands",
  BE: "Amazon Belgium",
  PL: "Amazon Poland",
  IE: "Amazon Ireland",
  SE: "Amazon Sweden",
  AE: "Amazon UAE",
  SA: "Amazon Saudi Arabia",
};

export function marketplaceCodeLabel(code: string | null | undefined): string {
  const trimmed = typeof code === "string" ? code.trim() : "";
  if (!trimmed) return safeCode(code);
  return MARKETPLACE_CODE_LABELS[trimmed.toUpperCase()] ?? trimmed;
}
